"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgSkipForward = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M17.625 15.22l10 8a1 1 0 010 1.56l-10 8A1 1 0 0116 32V16a1 1 0 011.625-.78zM31 16a1 1 0 011 1v14a1 1 0 01-2 0V17a1 1 0 011-1zm-13 2.08v11.84L25.4 24 18 18.08z",
    id: "skip-forward_svg__a"
  }));
};

var _default = SvgSkipForward;
exports.default = _default;